import React from 'react';

import {
  DownloadTag,
  MessageTag,
  PublishTagType,
  StatusTag,
} from 'config/CustomEnums';
import { COUPON_STATUS } from 'models/CouponListModel';

import { checkCampaignIsExpired } from 'utils/TimeFormatUtil';

import './CustomStatusTag.scss';

const TagType = {
  published: 'Published',
  unPublished: 'Unpublished',
  expired: 'Expired',
};

const getFormatedStatus = (campaign) => {
  if (!campaign.isPublished) {
    return {
      status: TagType.unPublished,
      className: 'custom-tag-label-un-publish',
    };
  }

  const isExpired = checkCampaignIsExpired(campaign.endDate);
  if (!isExpired) {
    return { status: TagType.published, className: 'custom-tag-label-publish' };
  }
  return { status: TagType.expired, className: 'custom-tag-label-expired' };
};

function CustomStatusTag(props) {
  const campaign = props.item;
  const tag = getFormatedStatus(campaign);
  return (
    <label className={`custom-tag-label ${tag.className}`}>{tag.status}</label>
  );
}

export const getCustomStatusClassName = (status) => {
  switch (status) {
    case StatusTag.active:
    case StatusTag.activated:
    case DownloadTag.completed:
    case MessageTag.scheduled:
    case MessageTag.sent:
    case MessageTag.sending:
    case DownloadTag.importCompleted:
    case COUPON_STATUS.ACTIVE_ACQUIRED:
    case COUPON_STATUS.ACTIVE:
    case PublishTagType.published:
      return 'custom-tag-label-publish';
    case StatusTag.deactivated:
    case StatusTag.deactive:
    case COUPON_STATUS.EXPIRED:
    case COUPON_STATUS.USED:
    case PublishTagType.expired:
    case DownloadTag.error:
    case MessageTag.error:
      return 'custom-tag-label-expired';
    case DownloadTag.cancelled:
    case StatusTag.inactive:
    case StatusTag.deleteRequested:
    case StatusTag.temporary:
    case StatusTag.temporaryEarning:
    case StatusTag.prospect:
    case MessageTag.saved:
    case COUPON_STATUS.INACTIVE:
    case PublishTagType.unPublished:
    case PublishTagType.draft:
    case PublishTagType.pendingForApproval:
      return 'custom-tag-label-un-publish';
    case DownloadTag.downloading:
    case DownloadTag.importing:
      return 'custom-tag-label-downloading';
    default:
      return '';
  }
};

export const CustomStatusTagFromText = (status, extraStyle) => {
  const statusClass = getCustomStatusClassName(status);

  return (
    <label className={`custom-tag-label ${statusClass} ${extraStyle}`}>
      {status}
    </label>
  );
};

export default CustomStatusTag;
